var Topic = Backbone.Model.extend({
    getTime: function () {
        if (this.get('time') > 0) {
            return new Date(this.get('time'));
        }
    },
    getText: function () {
        return this.get('topic');
    }
});


module.exports = Topic;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/topic.js
// module id = DyWj
// module chunks = 1